export { default } from './EmployeeList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeList/index.js